import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PostalCodeInputWUT from '../../../ui/address-input/postal-code-input-wut';
import { TextInputFieldWUT } from '../../../ui/text-input-field';
import JapanPostalCodeMarkWUT from './japan-postal-code-mark-wut';
const JapanPostalCodeWUT = _ref => {
  let {
    autocomplete,
    ...props
  } = _ref;
  const prefix = /*#__PURE__*/React.createElement(JapanPostalCodeMarkWUT, null);
  return autocomplete ? /*#__PURE__*/React.createElement(PostalCodeInputWUT, _extends({}, props, {
    prefix: prefix
  })) : /*#__PURE__*/React.createElement(TextInputFieldWUT, _extends({}, props, {
    prefix: prefix
  }));
};
export default JapanPostalCodeWUT;
//# sourceMappingURL=japan-postal-code-wut.js.map